module.exports = __webpack_public_path__ + "media/Video 96.cf0860e4.mp4";